module.exports = __webpack_public_path__ + "static/img/2020-11-18 17.05.12.21e1c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-11-18 17.05.12.jpg
// module id = 30JA
// module chunks = 4